import { InferGetStaticPropsType, NextPage } from "next";
import { Section, SectionContainer } from "@/components/Sections";
import { Markdown } from "@/components/Markdown";
import {
  ABOUT_WHY_HOW,
  AboutWhyHowSection,
} from "@/_staticContent/aboutWhyHow";
import config from "../config";
import { Head } from "@/components/Head";

export const getStaticProps = async () => {
  return {
    props: {
      whatWhyHowStatic: ABOUT_WHY_HOW,
    },
    revalidate: config.staticRevalidationTime,
  } as const;
};

type Props = InferGetStaticPropsType<typeof getStaticProps>;
const WhatWhyHowPage: NextPage<Props> = (props) => {
  function WhatWhyHowSection(props: {
    id: string;
    section: AboutWhyHowSection;
    className?: string;
    isFirstSection: boolean;
  }) {
    const { section } = props;
    return (
      <>
        <Head
          title="About Why & How"
          description="General information about Learning Opportunities and ECIU University."
        />
        <Section {...props} adjustScrollMarginToStickyObjectHeaderLinks={false}>
          <SectionContainer grid>
            <div className="col-span-full laptop-lg:col-span-8">
              <h2 className="text-style-headline2 mb-md">{section.header}</h2>
              <Markdown content={section.content} />
            </div>
          </SectionContainer>
        </Section>
      </>
    );
  }

  return (
    <>
      <h1 className="sr-only">About Why & How</h1>
      <WhatWhyHowSection
        id={"about"}
        section={props.whatWhyHowStatic.about}
        isFirstSection={true}
        className="bg-light-yellow"
      />
      <WhatWhyHowSection
        id={"why"}
        section={props.whatWhyHowStatic.why}
        isFirstSection={false}
        className="bg-grey-10"
      />
      <WhatWhyHowSection
        id={"how"}
        section={props.whatWhyHowStatic.how}
        isFirstSection={false}
        className="bg-light-blue text-white"
      />
    </>
  );
};

export default WhatWhyHowPage;
